if (!customElements.get('brands-slider')) {
  class BrandsSlider extends HTMLElement {
    selectors = {
      swiper: '[data-brands-swiper]',
      pagination: '.js-slider-dots',
    };
    settings = {
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      autoplay: this.hasAttribute('slider-autoplay')
        ? {
            delay: this.getAttribute('slider-autoplay'),
          }
        : false,
    };
    slider = undefined;
    id = undefined;
    dotContainers = undefined;

    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
    }

    init() {
      const swiper = this.querySelector(this.selectors.swiper);
      if (!swiper) return;

      this.slider = new Swiper(swiper, this.settings);
      this.dotContainers = this.querySelectorAll(this.selectors.pagination);
      for (const dotContainer of this.dotContainers) {
        dotContainer.addEventListener('click', (event) =>
          this.onDotClick(event),
        );
      }

      this.slider?.on('slideChange', this.updateDots.bind(this));
    }

    /**
     * Update active dots
     * @param {Object} e Event
     */
    updateDots(e) {
      const activeIndex = e.activeIndex;
      for (const dotContainer of this.dotContainers) {
        dotContainer.querySelectorAll('[data-dot-index]').forEach((dot) => {
          if (dot.dataset.dotIndex == activeIndex) {
            dot.setAttribute('active', true);
            return;
          }

          dot.removeAttribute('active');
        });
      }
    }

    /**
     * Handle dot click.
     *
     * @param {Event} event
     */
    onDotClick(event) {
      const index = event.target.getAttribute('data-dot-index');
      if (!index) return;
      this.slider.slideTo(index);
    }
  }
  customElements.define('brands-slider', BrandsSlider);
}
